import { render, staticRenderFns } from "./MasterEdit.vue?vue&type=template&id=61fafb08&scoped=true"
import script from "./MasterEdit.vue?vue&type=script&lang=js"
export * from "./MasterEdit.vue?vue&type=script&lang=js"
import style0 from "./MasterEdit.vue?vue&type=style&index=0&id=61fafb08&prod&lang=css"
import style1 from "./MasterEdit.vue?vue&type=style&index=1&id=61fafb08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fafb08",
  null
  
)

export default component.exports